'use client'

import { PortfolioListing } from '@/components/v2/portfolio/portfolio-listing'
import type { PortfolioCategory, PortfolioProject } from '@/components/v2/portfolio/portfolio-types'

interface Props {
  projects: PortfolioProject[]
  categories: PortfolioCategory[]
}

export function GalleryClient({ projects, categories }: Props) {
  return (
    <PortfolioListing
      projects={projects}
      categories={categories}
      detailBasePath="/gallery"
      searchPlaceholder="Search projects..."
    />
  )
}
